export const SBAT_GROUP_FILTERS = {
  primaryInstructors: 'primaryInstructors',
  secondaryInstructors: 'secondaryInstructors',
  academyModules: 'academyModules',
  academyTopics: 'academyTopics',
  superBatches: 'superBatches',
  fromDate: 'fromDate',
  toDate: 'toDate',
};
